import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useInView } from "react-intersection-observer";
import { downloadAppearanceImagesRequest } from "../../store/actions/ea-actions";

const useLazyImageLoad = (appearanceId, images) => {
  const dispatch = useDispatch();
  const imageCache = useSelector((state) => state.enrolledAppearanceReducer.imageCache);
  const imageLoadingStates = useSelector((state) => state.enrolledAppearanceReducer.imageLoadingStates);
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  useEffect(() => {
    if (!inView || !appearanceId) return;
    const imgs = Array.isArray(images) ? images : [];
    if (imgs.length === 0) return;
    const cacheForAppearance = imageCache[appearanceId] || {};
    const missingImages = imgs.filter((img) => {
      const key = img?.imageId;
      return key ? !cacheForAppearance[key] : true;
    });
    const { loading, error } = imageLoadingStates[appearanceId] || {};
    if (missingImages.length > 0 && !loading && !error) {
      dispatch(downloadAppearanceImagesRequest(appearanceId, missingImages));
    }
  }, [inView, appearanceId]);

  return ref;
};

export default useLazyImageLoad;
